class Permissions {
    constructor() {
        this.permissions = {
            edit: false,
            approve: false
        };
        this.loadPermissions();
    }

    loadPermissions() {
        const urlParams = new URLSearchParams(window.location.search);
        const localStoragePermissions = JSON.parse(localStorage.getItem('permissions')) || {};

        // Check URL params first
        if (urlParams.has('aar')) {
            this.permissions.approve = urlParams.get('aar') === '1';
        } else if (localStoragePermissions.approve !== undefined) {
            this.permissions.approve = localStoragePermissions.approve;
        }

        if (urlParams.has('ace')) {
            this.permissions.edit = urlParams.get('ace') === '1';
        } else if (localStoragePermissions.edit !== undefined) {
            this.permissions.edit = localStoragePermissions.edit;
        }

        // Ensure approve is a superset of edit
        if (this.permissions.approve) {
            this.permissions.edit = true;
        }
    }

    canEdit() {
        return this.permissions.edit;
    }

    canApprove() {
        return this.permissions.approve;
    }
}

export default Permissions;